import React, { useState, useEffect, useRef, useMemo } from 'react';
import { classNames } from 'primereact/utils';
import { InputText } from 'primereact/inputtext';
import { Dialog } from 'primereact/dialog';
import { Button } from 'primereact/button';
import { useFormik } from 'formik';
import { Toast } from 'primereact/toast';
import { translatedMessage } from '../../service/LanguageService';
import ValidationErrorModalComponent from '../../components/ValidationErrorModalComponent';
import { RecruitmentService } from '../../service/RecruitmentService';

const RecruitmentPlanEdit = (props) => {
    let emptyRecruitmentPlan = {
        id: null,
        recruitmentCampaign: { id: null, name: '' },
        institution: { id: null, name: '' }
    };

    const [recruitmentPlan, setRecruitmentPlan] = useState(emptyRecruitmentPlan);
    const [showValidationErrorDialog, setShowValidationErrorDialog] = useState(false);
    const [validationErrors, setValidationErrors] = useState([]);
    const [isNew, setIsNew] = useState(false);

    const recruitmentService = useMemo(() => new RecruitmentService(), []);

    const toast = useRef(null);

    useEffect(() => {
        let _recruitmentPlan = props?.value ? props.value : emptyRecruitmentPlan;
        setIsNew(_recruitmentPlan.id ? false : true);
        setRecruitmentPlan(_recruitmentPlan);

        // console.log("_recruitmentPlan: ", _recruitmentPlan)
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [props, recruitmentService]);

    const hideRecruitmentPlanDialog = () => {
        if (typeof props.visibleSetter === 'function') {
            props.visibleSetter(false);
        }
        setRecruitmentPlan(emptyRecruitmentPlan);
        formik.resetForm();
    };

    const saveRecruitmentPlan = (data) => {
        recruitmentService.saveRecruitmentPlan(data).then(
            (response) => {
                if (typeof props.afterSave === 'function') {
                    props.afterSave(response.recruitmentPlan, isNew);
                }
                toast?.current?.show({ severity: 'success', summary: translatedMessage('generic.save.success'), contentClassName: "pcn-toast-success" });
                hideRecruitmentPlanDialog()
            },
            (error) => {
                // console.log(error)
                if (error?.hasValidationError) {
                    setValidationErrors(error.errorCodes)
                    setShowValidationErrorDialog(true)
                } else {
                    error && toast?.current?.show({ severity: 'error', summary: translatedMessage(error.errorMessage), life: 7000 })
                }
            }
        );
    };

    const formik = useFormik({
        enableReinitialize: true,
        initialValues: recruitmentPlan ? recruitmentPlan : emptyRecruitmentPlan,
        validate: (data) => {
            let errors = {};            

            return errors;
        },
        onSubmit: (data) => {
            // console.log("saveRecruitmentPlan: ", data)
            saveRecruitmentPlan(data);
        }
    });

    const isFormFieldValid = (name) => !!(formik.touched[name] && formik.errors[name]);

    const getFormErrorMessage = (name) => {
        return isFormFieldValid(name) && <small className="p-error text-align-left">{formik.errors[name]}</small>;
    };

    const recruitmentPlanDialogFooter = (
        <>
            <Button label={translatedMessage('generic.cancel')} icon="pi pi-times" className="p-button-text" onClick={hideRecruitmentPlanDialog} />
            <Button label={translatedMessage('generic.save')} icon="pi pi-check" className="p-button p-button-primary" form="recruitmentPlan-form" type="submit" />
        </>
    );

    return (
        <>
            <Toast ref={toast} />

            <Dialog
                visible={props?.visible}
                header={recruitmentPlan?.id ? translatedMessage('recruitment.plan.edit') : translatedMessage('recruitment.plan.add')}
                modal
                resizable={false}
                className="pcn-dialog p-fluid"
                footer={recruitmentPlanDialogFooter}
                onHide={hideRecruitmentPlanDialog}
            >
                <form id="recruitmentPlan-form" onSubmit={formik.handleSubmit}>
                    <div className="field p-inputgroup mt-3 mb-2">
                        <span className="p-float-label">
                            <InputText type="text" name="recruitmentCampaign" id="recruitmentCampaign"
                                value={formik.values.recruitmentCampaign.name} onChange={formik.handleChange}
                                className={classNames({ 'p-invalid': isFormFieldValid('recruitmentCampaign') })} readOnly={true} />
                            <label htmlFor="recruitmentCampaign" className={classNames({ 'p-error': isFormFieldValid('recruitmentCampaign') })}>
                                {translatedMessage("recruitment.campaign")} *
                            </label>
                        </span>
                    </div>
                    {getFormErrorMessage('recruitmentCampaign')}

                    <div className="field p-inputgroup mt-3 mb-2">
                        <span className="p-float-label">
                            <InputText type="text" name="institution" id="institution"
                                value={formik.values.institution.name} onChange={formik.handleChange}
                                className={classNames({ 'p-invalid': isFormFieldValid('institution') })} readOnly={true} />
                            <label htmlFor="institution" className={classNames({ 'p-error': isFormFieldValid('institution') })}>
                                {translatedMessage("institution.institution")} *
                            </label>
                        </span>
                    </div>
                    {getFormErrorMessage('institution')}

                </form>
            </Dialog>

            {showValidationErrorDialog &&
                <ValidationErrorModalComponent
                    visible={showValidationErrorDialog}
                    errors={validationErrors}
                    dialogTitle={translatedMessage("recruitment.plan.save.error.title")}
                    closeDialog={() => setShowValidationErrorDialog(false)}
                />
            }
        </>
    );
};

export default RecruitmentPlanEdit;
